import {post, get} from '@/common/utils/Http';

export default {
  getGtCaptcha: post('/geetest/getGtCaptcha'),
  sendSmsCode: post('/login/sendSmsCode'),
  checkCode: post('/login/checkCode'),
  checkMobileRegister: post('/login/checkMobileRegister'),
  checkEmailRegister: post('/login/checkEmailRegister'),
  register: post('/login/register'),
  login: post('/login/login'),
  resetPassword: post('/login/resetPassword'),
  loginOut: post('/login/loginOut'),
  getLoginStatus: post('/login/getLoginStatus'),
  authStatus: post('/auth/authStatus'),
};
